<template>
  <div class="list-info">
    <ul class="list">
      <div class="title">
        <span class="total">{{ objTotalCount }}</span>개의 장비 및 서비스:
      </div>
      <li v-for="obj in objDefineList" :key="obj.objDefineId">
        <span>{{ ` ${obj.managetypeName} ${obj.cnt} ${getCountUnit(obj.objDefineId)}` }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import perfAPI from '@/api/performance/root';

export default {
  name: 'WEventInfo',
  data() {
    return {
      objTotalCount: 0,
      objDefineList: [],
    };
  },
  props: {
    active: {
      type: Boolean,
    },
  },
  watch: {
    active() {
      if (this.active) {
        this.loadData();
      }
    },
  },
  methods: {
    loadData() {
      perfAPI.getObjEventInfoForPerf({}).then((response) => {
        if (response.data.success) {
          const result = response.data.data;
          const objCount = result.objCount;
          const totalCount = result.totalCount;

          this.objDefineList = objCount;
          this.objTotalCount = totalCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); // 천단위 구분
        }
      });
    },
    getCountUnit(key) {
      // 수정 시 src\views\performance\node\summary\service\index.vue도 영향도 파악 필요.
      if (key === 'NETINTERFACE') {
        return '포트';
      } else if (['SERVER', 'NETDEVICE', 'DBMS'].indexOf(key) >= 0) {
        return '대';
      }
      return '개';
    },
  },
};
</script>

<style lang="scss" scoped>
.list-info {
  margin: 5px 0 12px 0; //190930 original:5px 20px 15px 0
  font-size: 13px;
  color: #555;
  .title {
    margin-right: 3px;
    .total {
      background: #1dc9b7;
      color: white;
      border-radius: 15px;
      padding: 3px 8px 2px;
      margin-right: 3px;
    }
  }
  .list {
    display: flex;
    align-items: center;
    margin-top: -2px;
    & > li {
      margin-top: 1px;
      padding: 0 0 0 2px;
      &:after {
        content: '/';
        font-size: 10px;
        position: relative;
        bottom: 1px;
        margin-left: 3px;
      }
      &:last-child:after {
        content: '';
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/performance/root/components/SummaryEventInfo.vue